<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">
        Changement d'offre MEF
    </div>
</div>

<div class="col-12 mt-4">
    @if (line) {
        <div class="line-details mb-4">
            <div class="row">
                <div class="col-6">
                    <strong>Ligne : </strong>{{ line.phoneNumber }}<br/><br/>
                    <strong>Offre : </strong>{{ line.offer.labelTunnel }} - {{ realOfferPrice }}€<br/><br/>
                </div>
                <div class="col-6">
                    <strong>Ligne activée le : </strong>{{ formatDate(line.billStartDate) }}<br/><br/>
                    @if (line.endCommitmentDate) {
                        <span><strong>Fin d'engagement le : </strong>{{ formatDate(line.endCommitmentDate) }}<br/><br/></span>
                    }
                </div>
            </div>
            <strong>Options : </strong>
            @if (filteredOptions.length > 0) {
                <div class="row pt-2 option-grid">
                    @for (option of filteredOptions; track option) {
                        <div class="col-12 mb-2">
                            - {{ option }}
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (line && line.status.toLowerCase() !== 'active') {
        <p class="line-error">La ligne n'est pas active.</p>
    }
    @if (categories.length === 0 && line && line.status.toLowerCase() == 'active') {
        <p class="line-error">La ligne n'est pas éligible à une montée en forfait</p>
    }

    @if (categories.length > 0 && line && line.status.toLowerCase() == 'active') {
        <div class="mb-4">
            <strong>Votre nouveau forfait prendra effet le : </strong> <span
                class="bold-blue-text">{{ this.changeOfferDateInterface.frenchDate }}</span>
        </div>
    }

    @if (categories.length > 0 && line && line.status.toLowerCase() == 'active' && line.phoneNumber.length === 10) {
        <div class="form-group">
            <div class="blue-color mb-2">Choisissez une catégorie dans la liste ci-dessous *</div>
            <select
                    name="category"
                    (change)="setSelectedCategory($event)"
                    class="form-control"
                    required
            >
                <option value="">Sélectionnez une catégorie</option>
                @for (category of categories; track category) {
                    <option value="{{ category }}">{{ category }}</option>
                }
            </select>
        </div>
    }

    @if (selectedCategory && selectedCategory != '') {
        <div class="form-group">
            <div class="blue-color mb-2">Choisissez une offre dans la liste ci-dessous *</div>
            <select
                    name="offer"
                    (change)="setSelectedOffer($event)"
                    class="form-control"
                    required
            >
                <option value="">Sélectionnez une offre</option>
                @for (offer of filteredOffers; track offer) {
                    <option value="{{ offer.offer_id }}">{{ offer.offer_label }} - {{ offer.base_price_ttc }}€</option>
                }
            </select>
        </div>
    }

    @if (selectedOfferDetails) {
        <div class="options-grid">
            <div class="section">
                @for (option of selectedOfferDetails.options_fmt.stand_alone_options; track option; let index = $index) {
                    <div>
                        <p class="{{ (option.requirement === 'mandatory' || (option.label_ec.toLowerCase().replace(' ', '-') == 'remise-multi-lignes')) ? 'disabled' : '' }}">
                            <input
                                    type="checkbox"
                                    name="option"
                                    [id]="'option' + index "
                                    [value]="option.label_ec"
                                    [checked]="option.requirement === 'mandatory' || isSelected(option.option_id) || (option.group_label && option.group_label.toLowerCase() === 'promo')"
                                    [disabled]="(option.requirement === 'mandatory' || (option.group_label && option.group_label.toLowerCase() === 'promo') || (option.label_ec.toLowerCase().replace(' ', '-') == 'remise-multi-lignes'))"
                                    (click)="setSelectedOptions($event, option.option_id, option.in_sale_ttc, option.label_ec, option.requirement)"
                            />
                            <label [for]="'option' + index " class="align-left">{{ option.label_ec }}</label>
                            <span class="bold">{{ option.in_sale_ttc.toFixed(2).replace('.', ',') }} €</span>
                        </p>
                    </div>
                }
                @for (optionGroups of selectedOfferDetails.options_fmt.option_groups; track optionGroups; let index = $index) {
                    <div class="pt-2">
                        @if (optionGroups.label.toLowerCase() !== 'etalement') {
                            <div>
                                <div class="pb-1 text-left">{{ optionGroups.label }}@if (optionGroups.requirements === 'mandatory') {
                                    <span class="bold-red-text">*</span>
                                }</div>
                                @for (option of optionGroups.options; track option) {
                                    <p class="group-options">
                                        <input
                                                type="radio"
                                                [name]="optionGroups.label"
                                                [id]="'option' + index "
                                                [value]="option.label_ec"
                                                [checked]="isSelected(option.option_id)"
                                                (click)="setSelectedOptions($event, option.option_id, option.in_sale_ttc, optionGroups.label, optionGroups.requirements, option.label_ec)"
                                        />
                                        <label [for]="'option' + index "
                                               class="align-left">{{ option.label_ec }}</label>
                                        <span class="bold">{{ option.in_sale_ttc.toFixed(2).replace('.', ',') }}
                                            €</span>
                                    </p>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }

    @if (submitted && invalidOptions) {
        <p class="error-msg">
            Merci de cocher les options obligatoires.
        </p>
    }
    @if (checkedDiscountBoxSfr) {
        <div>
            <div class="form-group radio-group">
                <input type="text" name="phoneNumber" placeholder="Identifiant Client SFR" class="form-control"
                       [(ngModel)]="sfrCustomerId"/>
                @if (submitted && ['', null].indexOf(this.sfrCustomerId) !== -1) {
                    <p class="error-msg">
                        Ce champ est obligatoire.
                    </p>
                }
            </div>
            <div class="form-group radio-group">
                <input type="text" name="phoneNumber" placeholder="Identifiant Commande SFR" class="form-control"
                       [(ngModel)]="sfrOrderId"/>
                @if (submitted && ['', null].indexOf(this.sfrOrderId) !== -1) {
                    <p class="error-msg">
                        Ce champ est obligatoire.
                    </p>
                }
            </div>
            <div class="form-group radio-group">
                <input type="text" name="phoneNumber" placeholder="Numéro d'appel SFR" class="form-control"
                       [(ngModel)]="sfrPhoneNumber"/>
                @if (submitted && ['', null].indexOf(this.sfrPhoneNumber) !== -1) {
                    <p class="error-msg">
                        Veuillez saisir un numéro de téléphone fixe ou mobile
                    </p>
                }
                @if (submitted && invalidSfrPhoneNumber && ['', null].indexOf(this.sfrPhoneNumber) == -1) {
                    <p class="error-msg">
                        Ce champ est invalide.
                    </p>
                }
            </div>
        </div>
    }

    <div class="row w-100 pt-3 text-center">
        <div class="col-12 w-100 cta_container">
            <button type="button" class="cta_cancel column column">Annuler<span></span></button>
            @if (selectedOffer) {
                <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                </button>
            }
        </div>
    </div>
</div>
